import React from 'react';
import Dropzone from 'react-dropzone';
import { DropContainer, UploadMessage } from './styles';
import { DEFAULT_MEDIA_ACCEPT } from 'utils/mediaFile';

export default function Upload({ onUpload, accept = DEFAULT_MEDIA_ACCEPT, disabled = false }) {
    const renderDragMessage = (isDragActive, isDragReject) => {
        if (!isDragActive) {
            return <UploadMessage>Arraste ou clique para enviar foto, vídeo ou PDF</UploadMessage>;
        }
        if (isDragReject) {
            return <UploadMessage type="error">Arquivo não suportado</UploadMessage>;
        }
        return <UploadMessage type="success">Solte os arquivos aqui</UploadMessage>;
    };

    return (
        <Dropzone disabled={disabled} accept={accept} multiple onDropAccepted={onUpload}>
            {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                <DropContainer {...getRootProps()} isDragActive={isDragActive} isDragReject={isDragReject}>
                    <input {...getInputProps()} />
                    {renderDragMessage(isDragActive, isDragReject)}
                </DropContainer>
            )}
        </Dropzone>
    );
}
